import { render } from "./SendToCourtDialog.vue?vue&type=template&id=32b07e97&scoped=true"
import script from "./SendToCourtDialog.vue?vue&type=script&lang=js"
export * from "./SendToCourtDialog.vue?vue&type=script&lang=js"

import "./SendToCourtDialog.vue?vue&type=style&index=0&id=32b07e97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b07e97"]])

export default __exports__